export const FULL_DEAL_EVENT_CATEGORY = 'Полная сделка МФО';
